import { SystemStyleObject } from '@chakra-ui/react';

export const baseStyles: SystemStyleObject = {
  rounded: 'full',
};
